import {
  GET_VOCABULARY,
  GET_VOCABULARY_SUCCESS,
  GET_VOCABULARY_ERROR,
} from "../actions";

export const getVocabulary = (vocabularyId, activityInfo) => ({
  type: GET_VOCABULARY,
  payload: { vocabularyId, activityInfo },
});

export const getVocabularySuccess = (vocabulary) => ({
  type: GET_VOCABULARY_SUCCESS,
  payload: vocabulary,
});

export const getVocabularyError = (message) => ({
  type: GET_VOCABULARY_ERROR,
  payload: { message },
});